module.exports = __webpack_public_path__ + "img/pure_oak_904m_detail_rsh.db67e00f.jpg";